// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__XP2Up","logo":"Footer_logo__jVqFi","wrap":"Footer_wrap__IG5jc"};